import axios from "axios";
import React, { useEffect, useState } from "react";
import { base_url } from "../../utils/AxiosConfig";

const LeavePopup = ({ LeaveEmpId, filteredData, setLeaveEmpId, apiData }) => {
  // console.log("LeaveEmpId:", LeaveEmpId);
  // console.log("apiData:", apiData);
  // console.log("filteredData:", filteredData);
  const [popupData, setpopupData] = useState();
  const [popupData2, setpopupData2] = useState();
  const [newData, setnewData] = useState();

  useEffect(() => {
    const LeaveDataofemp = filteredData?.filter(
      (data) => data.EmpID === LeaveEmpId,
    );

    fetchLeaveAllotmentData(LeaveEmpId);
    fetchAvlVSConsData(LeaveEmpId);
    // console.log(LeaveDataofemp);
    // setpopupData(LeaveDataofemp);
  }, [LeaveEmpId, filteredData]);

  const fetchLeaveAllotmentData = async (LeaveEmpId) => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    try {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveAllotment/${companyCode}/EMPLOYEE/${LeaveEmpId}`,
      );
      console.log("Allotment data", response.data);
      const data = response.data;
      setpopupData(data);
    } catch (err) {
      console.error("Error while fetching Allotment details", err);
    }
  };

  const fetchAvlVSConsData = async (LeaveEmpId) => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    try {
      const response = await axios.get(
        // `${base_url}/api/PersonalInfoLeaveAllotment/${companyCode}/EMPLOYEE/${LeaveEmpId}`
        `${base_url}/api/PersonalInfoLeaveStatusList/${companyCode}/LEAVESTATUS/${LeaveEmpId}/1900-01-01/1900-01-01/-`,
        // api/PersonalInfoLeaveStatusList LEAVESTATUS/CBM001/1900-01-01/1900-01-01/-
      );
      console.log("fetchAvlVSConsData data", response.data);
      const data = response.data;
      setpopupData2(data);
    } catch (err) {
      console.error("Error while fetching Allotment details", err);
    }
  };

  useEffect(() => {
    setnewData(popupData ? popupData[0] : null);
  }, [popupData]);

  useEffect(() => {
    const LeaveDataofemp = filteredData?.filter(
      (data) => data.EmpID === LeaveEmpId,
    );
    console.log("LeaveDataofemp", LeaveDataofemp);
    setpopupData(LeaveDataofemp);
  }, [LeaveEmpId, filteredData, apiData]);

  useEffect(() => {
    setnewData(popupData ? popupData[0] : null);
  }, [apiData]);

  return (
    <div>
      {LeaveEmpId && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black bg-opacity-50"
            onClick={() => setLeaveEmpId(null)}
          ></div>

          {/* Modal Content */}
          <div className="bg-white rounded-3xl shadow-lg z-50 w-11/12 max-w-4xl relative">
            {/* Header */}
            <div className="flex justify-between items-center bg-[#2663EB] rounded-t-3xl p-4">
              <h5 className="text-lg font-semibold text-white">
                Allotted Leave Details
              </h5>
              <button
                type="button"
                onClick={() => setLeaveEmpId(null)}
                className="absolute top-2 right-2 w-8 h-8 flex items-center justify-center rounded-full  text-white text-4xl font-bold transition-colors duration-200"
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            <div className="modal-body p-4">
              <div className="container">
                <div className="table-responsive">
                  <table className="table table-bordered align-middle text-sm">
                    <thead className="bg-[#2663EB]  ">
                      <tr className="border">
                        <th className="border-none text-white">Sl No</th>
                        <th className="border-none text-white">
                          Leave Category
                        </th>
                        <th className="border-none text-white">
                          Allotted Leaves
                        </th>
                        <th className="border-none text-white">
                          Settled Leaves
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {newData && newData.data?.length > 0 ? (
                        newData.data.map((d, i) => ( */}
                      {popupData && popupData?.length > 0 ? (
                        popupData.map((d, i) => (
                          <tr key={i} className="border">
                            <td className="border">{i + 1}</td>
                            <td className="border">{d.LeaveCategory}</td>
                            <td className="border">{d.NoOfLeaves}</td>
                            <td className="border-1">{d.settled_leaves}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="3"
                            className="text-center text-muted py-3 border-l-1 border-r-0"
                          >
                            No Data Available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="bg-[#2663EB]  px-3 py-3 text-left border-gray-200 mb-2">
              <h2 className="text-lg font-semibold text-white">
                Available vs Consumption
              </h2>
            </div>

            {/* <div className="modal-header bg-[#E4E7EB] border-bottom-0">
              <h5
              className="modal-title text-lg font-semibold text-gray-700"
              id="exampleModalLabel"
              >
              Allotted Leave Details
              </h5>
              <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => setLeaveEmpId(null)}
              ></button>
              </div> */}

            <div className="modal-body">
              <div className="container">
                <div className="table-responsive">
                  <table className="table table-bordered align-middle text-sm">
                    <thead className="bg-[#2663EB]  ">
                      <tr>
                        <th className="border-none text-white">Sl No</th>
                        <th className="border-none text-white">
                          Leave Category
                        </th>
                        <th className="border-none text-white">
                          Allotted Leaves
                        </th>
                        <th className="border-none text-white">
                          Consumed Leaves
                        </th>
                        <th className="border-none text-white">Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {newData && newData.data?.length > 0 ? (
                        newData.data.map((d, i) => ( */}
                      {popupData2 && popupData2?.length > 0 ? (
                        popupData2.map((d, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{d.LEAVECATEGORY}</td>
                            <td>{d.ALLOTED}</td>
                            <td>{d.CONSUMED}</td>
                            <td>{d.Balance}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="3"
                            className="text-center text-muted py-3"
                          >
                            No Data Available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* <div className="modal-footer bg-[#E4E7EB] border-top-0">
          <button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
            onClick={() => setLeaveEmpId(null)}
          >
            Close
          </button>
        </div> */}
          </div>
        </div>
      )}
    </div>

  );
};

export default LeavePopup;
